import { render, staticRenderFns } from "./wallet_in.vue?vue&type=template&id=4ba43e1c"
import script from "./wallet_in.vue?vue&type=script&lang=js"
export * from "./wallet_in.vue?vue&type=script&lang=js"
import style0 from "./wallet_in.vue?vue&type=style&index=0&id=4ba43e1c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports